import { ENDPOINT } from 'api/endPoints/getBaselineVsActual';

import { NoPermissionMessage } from 'components/Dashboards/Project/Components/CustomDashboard/utils/utils.contants';
import { IHashmapItemComponentProps } from 'components/Dashboards/Project/Components/CustomDashboard/utils/utils.type';
import { LARGE_SHORT, MEDIUM_SHORT } from 'components/Dashboards/Reporting/reportingConfig';

export const progressSummary: IHashmapItemComponentProps = {
    NoPermissionMessage,
    globalFiltersConfig: [
        { key: 'progressMeasurement', name: 'progressMeasurement', defaultValue: null },
        { key: 'milestoneFragnet', name: 'milestoneFragnet', defaultValue: null },
        { key: 'tags', name: 'tags', defaultValue: [] },
        { key: 'activityCodes', name: 'activityCodes', defaultValue: [] },
        { key: 'wbs', name: 'wbs', defaultValue: null },
        { key: 'resourceType', name: 'resourceType', defaultValue: null },
        { key: 'resource', name: 'resource', defaultValue: null },
    ],
    reportStyle: {
        widgetSizesAvailable: {
            mediumShort: MEDIUM_SHORT,
            largeShort: LARGE_SHORT,
        },
        widgetInitialSize: MEDIUM_SHORT,
    },
    reportConfig: {
        buttons: {
            narrative: false,
        },
        threeDotMenuOptions: {
            useAutomatedNarrative: true,
        },
        hideNarrativeEditor: true,
    },
    id: 'BaselineVsActual',
    componentKey: 'progressSummary',
    title: 'Progress Summary',
    endpoint: ENDPOINT,
};
